<template>
  <div class="contenedor w-full max-w-full flex flex-col items-center">
    <div id="inicio"></div>
    <div class="marco-azul relative h-fit w-screen ">
      <div class=" fondo-azul absolute right-auto top-0 ">
        <base-icon 
          v-if="!isUltrawide"
          icon-name="iconCintaAzul"              
          class="inline-block"
          view-box="0 0 2800 2070"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMax slice"
        >
          <icon-cinta-azul icon-color="black" />
        </base-icon>

        <base-icon 
          v-else
          icon-name="iconCintaAzul"              
          class="inline-block"
          view-box="0 0 2800 2070"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-cinta-azul-ancha icon-color="black" />
        </base-icon>
      </div>
      <div class="encuentro-box relative flex flex-col items-center sm:flex-row z-100">
        <div class="logo-encuentro relative sm:absolute">
          <base-icon 
            icon-name="ELRCA"              
            class="inline-block"
            view-box="0 0 450 610"
            width="100%"
            height="100%"
          >
            <icon-elrca />
          </base-icon>
        </div>   
        <div 
          class="encuentro-azul w-full flex justify-end "
        >
          <div
            class="
              w-fit
              flex flex-col
              items-center sm:items-start
              font-subheading
              whitespace-nowrap
            "
          >
            <div class=" encuentro-text-box text-center">
              <p class="text-naranjaamarillo transform: uppercase">
                Encuentro Latinoamericano
              </p>
              <p class="text-naranjaamarillo transform: uppercase">
                de Recreación Comunitaria.
              </p>
              <p class="abriendo text-naranjaencuentro">
                ABRIENDO EL JUEGO <span class="text-naranjaamarillo">en Santa Fe</span>
              </p>              
            </div>            
            <div class="fecha text-center pt-10 w-fit">
              <p class="mes text-naranjaencuentro">
                2026
              </p>
              <p class="numero text-naranjaamarillo drop-shadow">
                14, 15 y 16 de MAYO
              </p>
            </div>
            <p class="lugar font-heading text-2xl pt-4 pb-10 uppercase text-naranjaencuentro">
              La Redonda - Santa Fe - Argentina
            </p>

            <boton-ver-mas
              v-if="false"
              to="https://docs.google.com/forms/d/e/1FAIpQLSdLyelzqt-UKaLJhqSR1lQlkciMoBeE3XtFJ-guN3po47aUgQ/viewform"
              link-externo
              borde="border-white"
              color="text-white"
              texto="Quiero Inscribirme"
              class="encuentro bg-naranjaencuentro hover:text-black border-none 
              font-light text-2xl py-4 px-8 rounded-full self-center z-100 "
            >
            </boton-ver-mas>
          </div>
        </div>
      </div>
    </div>
    <div 
      class=" de-que-trata relative text-black w-5/6 md:w-4/6 mb-28 
      font-heading text-justify text-2xl leading-10 font-light mt-32
       flex flex-col"
    >
      <!-- <h2 class="font-subheading text-center text-4xl pb-8">
        ¿De qué se trata?
      </h2> -->
      <p class="py-4">
        Una nueva edición del <span class="font-bold text-naranjaencuentro "> Encuentro Latinoamericano de Recreación Comunitaria (ELRCAS 2026)</span>
        nos convoca a compartir los saberes, recorridos, experiencias de quienes transitan este campo en constante crecimiento.
        Una trama que va tejiendo su identidad a lo largo y a lo ancho de latinoamerica y se construye en comunidad.
      </p>

      <p class="py-4">
        Concebimos a la Recreación como derecho y práctica social que brinda oportunidades de vivencia del tiempo de
        manera libre y creativa, que promueve el protagonismo y una postura crítica y alternativa a propuestas consumistas y 
        que apuesta a la generación de procesos grupales fructíferos, participativos y comprometidos con su contexto histórico
        y social.
      </p>

      <p class="py-4">
        La <span class="font-bold text-naranjaencuentro">Recreación Comunitaria</span> se manifiesta en “lo común “: 
        <span class="font-bold text-naranjaencuentro">El territorio, el tiempo, la lúdica y la convivencia</span>, aspectos que se conjugan en
        el “reconocimiento de todas y cada una de las personas que componen una comunidad, que comparten un tiempo y 
        un territorio, se vinculan a través de lazos que se refuerzan en cada acción colectiva y construyen cultura desde el
        disfrute que ofrecen las diferentes formas del juego, el arte, la expresión y todas las manifestaciones identitarias
        atravesadas por la lúdica como dimensión humana, siendo su máxima expresión la fiesta comunitaria.
      </p>  

      <p class="py-4">
        Permite compartir la alegría, celebrar la vida, el encuentro, romper con la cotidianeidad, mover de lugar las estructuras,
        los supuestos y las jerarquías, modificar los espacios cotidianos. Instalar el juego en el centro de la escena, la apropiación
        comunitaria del espacio público y la incorporación sin distinciones de todas las personas.
      </p>

      <p class="py-4">
        Consideramos indispensable habilitar espacios de formación y construcción de conocimiento, encontrando juntxs las mejores
        alternativas pedagógicas para acompañar estos procesos colectivos. Para contar con educadoras y educadores inventores/as
        y creadores/as de propuestas con identidad cultural, que promuevan experiencias que respeten necesidades y deseos de cada 
        grupo y comunidad en un clima de alegría y esperanza con la convicción de la potencia transformadora de la recreación
      </p>

      <p class="py-4">
        En este encuentro, en particular pondremos énfasis en los ejes “Territorio, identidad y memoria”. Porque entendemos que
        es en cada territorio donde florecen las mejores acciones colectivas, donde se construye identidad, donde se disputa sentido
        y celebramos la memoria como presente y futuro y como forma irrestricta de defensa de nuestra democracia. A 50 años del
        golpe cívico militar seguimos construyendo esperanza y jugando (nos) en cada acción cotidiana para seguir tejiendo tramas
        que nos sostengan.
      </p>

      <p class="py-4">
        <span class="font-bold text-naranjaencuentro">Destinatarios/as:</span>
      </p>

      <p class="py-4">
        Educadores/as de todos los niveles y modalidades, estudiantes y profesores de carreras de formación docente, artística y
        técnica, trabajadores/as de la cultura, recreadores/as, trabajadores/as sociales, referentes territoriales y trabajadores/as
        de distintos efectores estatales, y otras personas interesadas en la temática.
      </p>

      <p class="py-4">
        <span class="font-bold text-naranjaencuentro">Organización de la propuesta</span>
      </p>

      <p class="py-4">
        Se pondrán a disposición diferentes espacios y formatos a través de los cuales vivenciar, conocer y compartir las distintas
        experiencias, producciones, y construcciones del campo del juego y la recreación que se desarrollan en nuestra provincia,
        nuestro país y en toda Latinoamérica.
      </p>

      <p class="py-4">
        En el marco del Encuentro Latinoamericano de Recreación Comunitaria 2026, se llevará a cabo una nueva edición de la Feria del Libro
        <span class="font-bold text-naranjaencuentro">“Lúdica, Juego y Recreación”</span> en cuyo ámbito se habilitará un espacio para la presentación
        de libros y revistas especializadas en la temática.
      </p>

      <boton-ver-mas
        v-if="false"
        :to="rooturl + '/articulos/elrcas-2026'" 
        link-externo
        borde="border-white"
        color="text-white"
        texto="Leer Más"
        class="encuentro bg-naranjaencuentro hover:text-black text-2xl px-4 py-4 rounded-full
          border-none font-light self-center"
      >
      </boton-ver-mas>      
    </div>
    <div
      class="box-contenido relative text-azul
          w-5/6
          mt-16 mb-16
          font-heading text-justify text-2xl leading-10 font-light
        "
    >
      <div id="vivo"></div>
      <div
        v-if="false"
        class="contenido text-left sm:text-justify"
        v-html="encuentro2026Vivo.contenido"
      ></div>
    </div>
    <div
      class="box-contenido relative text-azul
          w-5/6
          mt-16 mb-40
          font-heading text-justify text-2xl leading-10 font-light
        "
    >
      <div id="programa"></div>
      <div
        class="contenido text-left sm:text-justify"
        v-html="encuentro2026Programa.contenido"
      ></div>
    </div>
    <div 
      class="inscripciones relative w-screen max-h-full"
    >
      <div class="contenedor-imagen-inscripcion absolute w-full">
        <base-icon 
          v-if="!isMovil&&!isUltrawide"
          icon-name="CurvaInscripcion"              
          class="inline-block"
          view-box="0 0 1400 1040"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-curva-inscripcion icon-color="black" />
        </base-icon>
        <base-icon 
          v-else-if="isUltrawide"
          icon-name="CurvaInscripcionUltrawide"              
          class="inline-block"
          view-box="-15 0 2300 1050"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-curva-inscripcion-grande icon-color="black" />
        </base-icon>
        <base-icon 
          v-else
          icon-name="CurvaInscripcionMovil"              
          class="inline-block"
          view-box="0 -0 1220 1930"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <icon-curva-inscripcion-movil icon-color="black" />
        </base-icon>
      </div>

      <div 
        class=" w-full max-w-full h-fit text-naranjaencuentro
        flex flex-col justify-center"
      >
        <div id="inscripcion"></div>
        <div
          v-if="true"
          class="inner-inscripciones flex flex-col font-light items-center relative z-200 font-heading"
        >
          <h2 class="text-4xl inline w-fit mb-10 font-bold px-10 text-center ">            
            INSCRIPCIONES ABIERTAS
          </h2>
          <p class=" texto-inscripcion  text-2xl ">
            Hacé click e inscribite para participar 
          </p>

          <boton-ver-mas
            to="https://docs.google.com/forms/d/e/1FAIpQLSd_ch79jjAhen1hNgVK0NUG-KFHAoXnPka_NfgP9AEkZU2OOg/viewform?usp=dialog"
            link-externo
            color="text-white"
            texto="Quiero Inscribirme"
            class="encuentro bg-black hover:text-black hover:bg-naranjaamarillo text-2xl px-4 py-4 rounded-full 
            border-solid border-2 font-light text-naranjaamarillo"
          >
          </boton-ver-mas>   

          <p class=" texto-inscripcion font-heading text-2xl pb-4 ">
            ¡Te esperamos!
          </p>
          <div
            class="
              encuentro-inscripciones 
              max-w-full
              text-2xl
              text-center
              flex
              flex-col 
              py-8
            "
          >
            <span class="text-naranjaamarillo">
              Encuentro Latinoamericano
            </span>
            <span class="text-naranjaamarillo">
              de Recreación Comunitaria.
            </span>
            <span class="text-naranjaencuentro">
              Abriendo el Juego en Santa Fe
            </span>         
          </div>
          <div class=" fecha-inscripcion font-subheading text-azuloscuro py-10 w-fit">
            <p class="  text-3xl drop-shadow">
              14, 15 y 16 de MAYO
            </p>
          </div>
          <p class=" lugar-inscripcion text-naranjaamarillo  text-2xl pb-14 ">
            La Redonda - Santa Fe
          </p>   
        </div>
      </div>
    </div>



    <div 
      v-if="false"
      class=" contenedor-propuesta text-naranjaamarillo w-5/6 xl:w-full flex items-center flex-col mt-40 z-1 relative"
    >
      <div id="propuesta"></div>
      <h2 
        class="text-4xl sm:text-5xl  inline w-fit  mb-10 sm:mb-20 font-subheading font-bold uppercase text-center"
      >
        Desarrollo de las Propuestas
      </h2>
      <p 
        v-if="false"
        class="text-naranjaamarillo w-5/6 md:w-4/6 font-heading text-justify text-2xl leading-10 font-bold mb-10"
      >
        Clickear
      </p>
      <div 
        class="contenedor-iconos-prop grid grid-cols-1 sm:grid-cols-3 gap-20 sm:gap-6 xl:gap-12 xl:my-8
       justify-items-center "
      >
        <item-propuesta 
          color="rgba(222, 200, 20, 1)"
          icono="Dice"
          text1="Dispositivos"
          text2="Lúdicos"         
          image-name="dispositivos"
          doble
          ruta="https://www.abriendoeljuego.ar/home/articulos/dispositivos-ludicos-2026/"
        >
          <icon-dice />
        </item-propuesta>
        <item-propuesta 
          color="rgba(220, 163, 23, 1)"
          icono="Dice"
          text1="Rondas de"
          text2="Socialización"
          doble
          image-name="rondas"
          ruta="https://www.abriendoeljuego.ar/home/articulos/rondas-2026/"
        >
          <icon-mensaje />
        </item-propuesta>
        <item-propuesta 
          color="rgba(27, 132, 42, 1)"
          icono="Dice"
          text1="Recorridos"
          text2="Lúdicos" 
          view-box="22 34 85 90"       
          image-name="recorridos"
          ruta="https://www.abriendoeljuego.ar/home/articulos/recorridos-ludicos-2026/"
        >
          <icon-feria />
        </item-propuesta>
        <item-propuesta 
          color="rgba(57, 36, 216, 1)"
          icono="Dice"
          text1="Feria"
          text2="de libros"
          image-name="libros"
          doble
          ruta="https://www.abriendoeljuego.ar/home/articulos/feria-de-libros-2026/"
        >
          <icon-libros />
        </item-propuesta>
        <item-propuesta 
          color="rgba(216, 36, 54, 1)"
          icono="Dice"
          text1="Talleres"
          text2="null" 
          view-box="0 0 57 77"  
          image-name="talleres" 
          ruta="https://www.abriendoeljuego.ar/home/articulos/talleres-2026/"           
        >
          <icon-taller />
        </item-propuesta>
        <item-propuesta 
          color="rgba(172, 24, 221, 1)"
          icono="Dice"
          text1="Territorio"
          text2="null" 
          view-box="3 0 18 23"         
          image-name="territorio" 
          ruta="https://www.abriendoeljuego.ar/home/articulos/territorios-2026/"           
        >
          <icon-ubicacion />
        </item-propuesta>
      </div>
    </div>
    <div
      v-if="false" 
      class="boton-descargar m-10 z-50"
    >
      <boton-ver-mas
        link
        to="http://localhost/abriendo-el-juego/wp-content/uploads/2022/04/Dibujo1.pdf"
        archivo
        borde="border-white"
        color="text-white"
        download
        texto="Descargar programa completo"
        class="encuentro bg-naranja hover:text-black text-2xl px-4 py-4 rounded-full  
        border-none font-light my-24"
      >
      </boton-ver-mas>   
    </div>

    <div
      class="box-contenido relative text-azul
          w-5/6
          mt-16 mb-16
          font-heading text-justify text-2xl leading-10 font-light
        "
    >
      <div
        class="contenido text-left sm:text-justify"
        v-html="encuentro2026.contenido"
      ></div>
    </div>
  </div>
</template>

<script>
// import { defineAsyncComponent } from 'vue'
import goSectionMixin from '@/mixins/goSectionMixin.js';
import assetsHandle from "@/mixins/AssetsHandle.js";
import visibilityHandle from '@/mixins/visibilityHandle.js';
import IconCintaAzul from '../components/UI/icons/iconCintaAzul.vue';
import IconCintaAzulAncha from '../components/UI/icons/iconCintaAzulAncha.vue';
import IconCurvaInscripcion from '../components/UI/icons/iconCurvaInscripcion.vue';
import IconCurvaInscripcionMovil from '../components/UI/icons/iconCurvaInscripcionMovil.vue';
import IconCurvaInscripcionGrande from '../components/UI/icons/iconCurvaInscripcionGrande.vue';
import ItemPropuesta from '../components/Encuentro/ItemPropuesta.vue'

export default {
  components: {IconCintaAzul, IconCintaAzulAncha,IconCurvaInscripcion, IconCurvaInscripcionMovil, IconCurvaInscripcionGrande, ItemPropuesta
  },
  mixins: [goSectionMixin, visibilityHandle, assetsHandle],
  data () {
    return {
      publicPath: "https://abriendoeljuego.ar/wp-content/plugins/wp-vuecli-plug/dist/img/"
    }
  }, 
  computed: {
    encuentro2026Vivo() {
      return this.$store.getters["wordpress/getEncuentro2026Vivo"];
    },
    encuentro2026Programa() {
      return this.$store.getters["wordpress/getEncuentro2026Programa"];
    },
    encuentro2026() {
      return this.$store.getters["wordpress/getEncuentro2026"];
    },
    rooturl(){
      //console.log(this.$store.getters.getRootURL)
      return this.$store.getters.getRootURL
    },
  },
  created() {
    this.loadEncuentro();
  },
  methods: {
    loadEncuentro() {
      this.$store.dispatch("wordpress/loadPosts", "encuentro2026");
      this.$store.dispatch("wordpress/loadPosts", "encuentro2026programa");
      this.$store.dispatch("wordpress/loadPosts", "encuentro2026vivo");
    },
  },

}
</script>

<style>
  .contenido p {
    padding: 1rem;
  }

  @media screen and (max-width: 640px) { 
    .second .icono {
      height: 4rem !important;
    }

    .contenido p {
      font-size: 1.5rem;
    }

    .contenido p.has-large-font-size {
      font-size: 2rem;
    }
    
  }
</style>

<style scoped>



  .sponsors li {
    list-style: none;
  }

  .contenedor-isotipo {
    width: 20rem;
  }

  .marco-azul {
    padding-top: 4rem;
    padding-bottom: 8rem;
  }

  .fondo-azul{
    height: 100%;
    /* width: 51rem;
    left: -20rem; */
    /* background-image: url(../assets/cinta-azul.png);
    background-repeat: no-repeat;
    background-color: transparent;
    background-position: center bottom ;
    background-size: 100%;
    height: 406px; */
    /* width: 280vw; */
    left: -47%;
    width: 180%;
  }


  .encuentro-box {
    width: 100%;
  }
    
  .logo-encuentro {
    width: 148px;
    margin-bottom: 5vw;
  }

  .encuentro-text-box {
    font-size: 5vw;
    line-height: 6vw;
    letter-spacing: 0.01em;
  }

  .encuentro-text-box .abriendo {
    font-size: 4vw;
  }

  .encuentro-azul {
    border-radius: 27px;
    font-size: 2.1vw;
    line-height: 3vw;

    margin-right: 0vw;
    margin-left: 0vw;
    margin-top: 0vw;
    margin-bottom: 5px;
    padding: 0;

    width: 100%;
    justify-content: center;
  }

  .lugar {
    font-weight: 600;
    font-size: 3vw;
  }

 .fecha {
    text-shadow: 4px 4px 6px rgb(0 0 0 / 50%);
    font-size: 6vw;
    line-height: 8vw;
    padding-top: 0;
  }

  .fecha .mes {
    line-height: 16vw;
    font-size: 14vw;
  }

  .button-ver-mas.encuentro {
    padding: 0.7rem 2rem;
    font-size: 1.5rem;
    margin: 0;
    margin-top: 3vw;
    border-color: rgba(218, 162, 23, 100);
    border-width: 2px;
  }

  .contenedor-imagen-inscripcion {
    width: 100%;
    height: 100%;
  }
    
  .inner-inscripciones {
    margin: 0px;
    padding: 15vw 3vw;
  }

  .inner-inscripciones a {
    margin-top: 20px;
  }
  
   .inner-inscripciones h2 {
    margin-top: 20px;
    font-size: 5vw;
    line-height: 6vw;
  }
  .fecha-inscripcion  {
    padding: 1vw;
  }

  .fecha-inscripcion p {
    font-size: 3.5vw;
  }

  .lugar-inscripcion {
    font-size: 3vw;
    padding: 1vw;
  }

  .texto-inscripcion {
    font-size: 4vw;
    padding: 3vw;
  }

  .encuentro-inscripciones {
    font-size: 3.0vw;
    line-height: 4vw;
    padding: 3vw 1vw 1vw;
  }

  .prop-item .text{
    font-size: 4vw !important
  }

  .boton-descargar {
    margin: 50px 5px;
    ;
  }
@media screen and (max-width: 240px) { 
  .marco-azul {
    padding-top: 4rem;
    padding-bottom: 8rem;
  }
  
  .button-ver-mas.encuentro {
    padding: 1.5vw 10vw;
    font-size: 7vw;
    margin: 0;
  }
  .fondo-azul{
    width: 51rem;
    left: -20rem;
  }
      
  .logo-encuentro {
    width: 60vw;
    margin-top:2rem
  }

  .lugar {
    padding: 4vw 0;
    line-height: 5vw;
  }


}
@media screen and (min-width: 450px) { 

  .encuentro-text-box {
    font-size: 4.5vw;
    line-height: 5vw;
  }

  .encuentro-text-box .abriendo {
    font-size: 3.6vw;
    line-height: 4vw;
  }

  /*fondo-azul{
    /* width: 229vw;
    left: -75% */
  /* } */
  

  .logo-encuentro {
    width: 45vw;
  }

  .fecha {
    font-size: 6vw;
    line-height: 8vw;
    padding-top: 3vw;
  }

  .fecha .mes {
    font-size: 17.5vw;
    line-height: 18.5vw;
  }

  .lugar {
    font-size: 3vw;
  }

 /* .marco-azul {
    /* padding-top: 36px;
    padding-bottom: 9rem;*/
 /* }*/

  .encuentro-azul {
    font-size: 2.1vw;
    line-height: 3vw;

    padding: 4vw 7vw 5vw 7vw;
  }

  .boton-descargar {
    margin: 2.5rem;
  }

  .de-que-trata {
    margin-top: 15vw;
  }

  .contenedor-propuesta{
    margin-top: 10rem;
    margin-bottom: 16rem
  }

  .organiza {
    width: 70%;
  }

  .contenedor-imagen-inscripcion {
    width: auto;
    /* height: 200vw; */
    height: 100%;
    min-width: 100%;
  }

  .inner-inscripciones {
    /* padding: 40vw 3vw; */
    padding: 15vw 3vw;
  }

  .inner-inscripciones h2{
    margin: 5vw ;
  }

  .button-ver-mas.encuentro {
    margin: 0;
  }

  }

@media screen and (min-width: 600px) {
  .fondo-azul {
    width: 230vw;
    left: -65vw;
  }

.marco-azul {
  padding-top: 10rem;
  padding-bottom: 20vw;
}

.encuentro-box {
  width: 100%;
  height: fit-content;
  padding: 0 0 0 0;
  margin:0;
}

.encuentro-azul {
  padding: 3.6vw 0vw 3vw 25vw;
  height: fit-content;
  margin: 0 0vw;
  max-width: 100%;
  justify-content: flex-start;
}

.logo-encuentro {
    height: 47vw;
    width: auto;
    /* left: 10vw; */
    top: -9vw;
    right: 4vw;
  position: absolute;
}

.encuentro-azul div {
  align-items: flex-start;
}

.encuentro-text-box {
  text-align: start;
  font-size: 2.6vw;
  line-height: 4.2vw;
}

.encuentro-text-box .abriendo {
  font-size: 2.6vw;
  line-height: 4.2vw;
}

.inner-inscripciones .button-ver-mas.encuentro{
  margin: 0rem;
} 

.fecha {
  text-align: start;
  margin: 0 0;
  /* padding-top: 4.5vw; */
}

.fecha .mes {
  font-size: 18vw;
  line-height: 15vw;
}

.fecha .numero {
  font-size: 4.6vw;
  line-height: 6vw;
}

.lugar {
  font-size: 2.3vw;
  line-height: 2.3vw;
  padding-bottom: 4vw;
  padding-top: 0vw;
}

.logo-encuento img {
  height: 100%;
  width: 100%;
}

  /* a {
    font-size: 1.5rem;
    padding: 0.7rem 1.5rem;
    margin: 0 0;
  } */

  .de-que-trata {
    margin-top: 5vw;
  }

  .contenedor-imagen-inscripcion {
    /* height: 65rem; */
    height: 42rem;
    width: 100vw;
  }

  .inner-inscripciones {
    padding: 8vw 4vw;
  }


  .inner-inscripciones h2{
    margin: 3vw 3vw 1vw;
    font-size: 3.4vw;
    line-height: 4vw;
  }
  
  .encuentro-inscripciones {
    font-size: 2.0vw;
    line-height: 3.0vw;
    display: inline-block;
    width: 63vw;
    padding: 2vw 2vw 1vw;
  }

    .encuentro-inscripciones span {
      display: inline;
      white-space: normal;
    }


  .fecha-inscripcion {
    padding: 1vw 1vw 1vw 1vw;
  }

  .fecha-inscripcion p {
    font-size: 2.6vw;
    line-height: 3%;
  }

  .lugar-inscripcion {
    font-size: 2.0vw;
    line-height: 3vw;
    padding: 1vw 1vw 1vw 1vw;
  }

  .texto-inscripcion {
    font-size: 2.5vw;
    line-height: 3.5vw;
    padding: 1vw 1vw 1vw;
  }

  .inner-inscripciones a{
    margin: 3vw;
  }

  .contenedor-iconos-prop {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sponsor-icons {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .organiza {
    margin-top: 15rem;
    width: 50%;
  }
}

@media screen and (min-width: 769px) {

  .fondo-azul {
    width: 200rem;    
    left: auto;
  }
  
  .marco-azul {
    padding-top: 10rem;
    padding-bottom: 16rem;
    display: flex;
    justify-content: center;
  }
  
  .encuentro-box {
    margin:0;
    width: 78rem;
  }

  .logo-encuentro {
    height: 38rem;
    width: auto;
    top: -5.5rem;
    right: 4vw;
  }

  .encuentro-text-box {
    
    font-size: 2.2rem;
    line-height: 2.5rem;
  }

  .encuentro-azul {
    padding: 6rem 0 4rem 17rem;
  }

  .fecha {
    font-size: 3rem;
    line-height: 4rem;
    padding-top: 1rem
  }

  .fecha .mes {
    font-size: 12rem;
    line-height: 11rem;
    text-align: center;
  }

 .encuentro-text-box .abriendo {
    font-size: 1.9rem;
    line-height: 2rem;
  }

  .fecha .numero {
    font-size: 3rem;
    line-height: 4rem;
  }

  .lugar {
    font-size: 1.8rem;
    line-height: 2rem;
    padding-bottom: 2rem;
    padding-top: 0;
  } 

  .contenedor-imagen-inscripcion {
   height: 63rem;
  } 

  .inner-inscripciones {
    padding: 9rem 8rem;
  }

  .inner-inscripciones h2{
    margin: 3rem;
    font-size: 3.3rem;
    line-height: 4rem;
  }

  .fecha-inscripcion {
    padding: 0.5rem;
    margin-top: 0;
  }

  .fecha-inscripcion p {
    padding: 0.5rem;
    font-size: 2.5rem;
    line-height: 3rem;
  }

  .lugar-inscripcion {
    padding: 0.5rem;
    font-size: 2em;
    line-height: 2.5rem;
    margin: 0 0rem 1rem 0rem
  }

  .texto-inscripcion {
    padding: 1.5rem;
    font-size: 2.1em;
    line-height: 2.0rem;
  } 

  .encuentro-inscripciones {
    padding: 1.5rem;
    font-size: 2rem;
    line-height: 3rem;
    width: 50rem;
  }

  .inner-inscripciones .button-ver-mas.encuentro {
    font-size: 2.5rem;
    border-width: 3px;
    padding: 1.5rem 2rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  /* 



  /* a {
    margin: 0;
    padding: 1rem 2.5rem;
    font-size: 2rem;
  } */

  /* .de-que-trata {
    margin-top: 9rem;
  }

  .contenedor-imagen-inscripcion {
   height: 70rem;
  } */

  /* .inner-inscripciones {
    padding: 7rem 8rem;
  }

*/

  /* .inner-inscripciones h2{
    margin: 5rem;
    font-size: 3.3rem;
    line-height: 4rem;
  }

  .fecha-inscripcion {
    padding: 0.5rem;
    margin-top: 4rem;
  } */

  /* .fecha-inscripcion p {
    padding: 0.5rem;
    font-size: 4.5rem;
    line-height: 5rem;
  } */

  /* .lugar-inscripcion {
    padding: 0.5rem;
    font-size: 2em;
    line-height: 2rem;
    margin: 3rem 0rem 5rem 0rem
  } */
/* 
  .texto-inscripcion {
    padding: 0.2rem;
    font-size: 2.1em;
    line-height: 2.0rem;
  } */

  /* .encuentro-inscripciones {
    font-size: 2.0rem;
    line-height: 3.0rem;
    width: 50rem;
  } */

   /*.text-azulOscuro {
    margin-top: 8rem; 
  }*/

  /* .organiza {
    margin-top: 10rem;
    width: 50%;
  } */

}

@media screen and (min-width: 1300px) {
  
  .fondo-azul {   
    left: auto;
    width: 120%;
  }

  .marco-azul {
    padding-top: 12rem;
    padding-bottom: 15rem;
  }

  .button-ver-mas.encuentro {
    padding: 0.7rem 3rem;
    font-size: 2.0rem;
    margin: 0;
  }

  .encuentro-box {
    width: 56rem;
  }

  .encuentro-azul {
    padding: 4rem 0rem 0 0;
  }

  .logo-encuentro {
    height: 47rem;
    left: 0;
    top: -7rem;
    right: -48rem;
  }

  .contenedor-imagen-inscripcion {
   height: 63rem;
   /* height: 80rem; */
  } 
}
</style>